const burgerToggle = document.querySelector("#burger-toggle");
const main = document.querySelector("body > main");
const aside = document.querySelector("body > aside");
const footer = document.querySelector("body > footer");
const html = document.querySelector("html");

const isEng = html.getAttribute("lang") === "en-GB";
let menu;
isEng
  ? (menu = document.querySelector("#menu-menu-principal-en"))
  : (menu = document.querySelector("#menu-menu-principal"));

const menuItemMobile = document.querySelectorAll(".menu-item-has-children");

window.addEventListener("click", (e) => {
  !burgerToggle.contains(e.target) && !menu.contains(e.target) && closeMenu();
});

burgerToggle.addEventListener("click", () => {
  let isOpen = burgerToggle.getAttribute("aria-expanded") === "true";

  isOpen ? closeMenu() : openMenu();
});

const closeMenu = () => {
  burgerToggle.setAttribute("aria-expanded", "false");
  main.classList.remove("blur");
  aside?.classList.remove("blur");
  footer.classList.remove("blur");
  html.classList.remove("noscroll");
};

const openMenu = () => {
  burgerToggle.setAttribute("aria-expanded", "true");
  main.classList.add("blur");
  aside?.classList.add("blur");
  footer.classList.add("blur");
  html.classList.add("noscroll");
};

menuItemMobile?.forEach((item) => {
  item.addEventListener("click", () => {
    let subMenuIsOpen = item.getAttribute("aria-expanded") === "true";

    subMenuIsOpen
      ? item.setAttribute("aria-expanded", "false")
      : item.setAttribute("aria-expanded", "true");
  });
});
